import request from '@/utils/request'
// import qs from "qs";

const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: { object: {} },
	sign: 'dafdsf'
}

// 分页查询注销人员列表
export function personalLogOut (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custInfo/pageCancelCustInfo',
		method: 'post',
		data: obj
	})
}
// 批量导入人脸
export function pldaoruRenlian (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custInfo/registerFace',
		method: 'post',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
		data
	})
}
// 获取所有设备信息
export function getShebeis (data) {
	const obj = JSON.parse(
		JSON.stringify({
			version: '1.0',
			nonceStr: '1212fsadf',
			timestamp: '2020-4-21',
			signType: 'md5',
			sign: 'dafdsf',
			content: ''
		})
	)
	return request({
		url: '/api/v1/machine/getPayMachineList',
		method: 'post',
		data: obj
	})
}
// 批量导入结果查询
export function pldaoruResult (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custInfo/batch/error/page',
		method: 'post',
		data: obj
	})
}
// 设备统一收单支付
export function bukou (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/acc/repair/deduct/single',
		method: 'post',
		data: obj
	})
}
// 订单明细退款功能
export function tuikuan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/acc/refund/accrefund',
		method: 'post',
		data: obj
	})
}
// 订单明细退单功能
export function tuidan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ordInfo/whole/order/back',
		method: 'post',
		data: obj
	})
}
// 分页查询组织结构
export function getZuzhiList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custOrg/queryPageCustOrg',
		method: 'post',
		data: obj
	})
}

// 树状查询机构信息
export function getZuzhiTree (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custOrg/tenant/tree',
		method: 'get',
		params: obj
	})
}

// 根据id修改组织机构
export function editZuzhiById (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custOrg/updateCustOrgById',
		method: 'put',
		data: obj,
		encryption: ['orgTel']
	})
}

// 新增组织机构
export function addZuzhi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custOrg/addCustOrg',
		method: 'post',
		data: obj,
		encryption: ['orgTel']
	})
}

// 根据id删除组织机构
export function delZuzhiById (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custOrg/deleteCustOrgByOrgId',
		method: 'delete',
		data: obj
	})
}

// 分页查询位置信息
export function getAddressList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custPlace/queryPageCustPlace',
		method: 'get',
		params: obj
	})
}

// 树状查询位置信息
export function getAddressTree (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custPlace/queryTreeCustPlace',
		method: 'get',
		params: obj
	})
}

// 树状查询位置信息
export function getAddressLazyTree (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custPlace/place/tree',
		method: 'get',
		params: obj
	})
}

// 根据id删除位置信息
export function delAddressById (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custPlace/deleteCustPlaceByPlaceId',
		method: 'delete',
		data: obj
	})
}

// 根据id修改位置信息
export function editAddressById (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custPlace/updateCustPlaceById',
		method: 'put',
		data: obj
	})
}

// 新增位置信息
export function addAddress (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custPlace/addCustPlace',
		method: 'post',
		data: obj
	})
}
// 批量生成位置信息二维码
export function batchGenerateCode (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custPlace/batch/generate-QRCode',
		method: 'POST',
		data: obj
	})
}
// 批量删除位置信息
export function batchDeleteCode (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custPlace/deleteCustPlaceByPlaceId',
		method: 'DELETE',
		data: obj
	})
}
// 导入位置信息校验/位置信息导入
export function exportPosition (data, insert) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/custPlace/import?insert=${insert}`,
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		method: 'post',
		data
	})
}
// 分页查询人员资料
export function getRenyuanList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custInfo/pageCustInfoPhoto',
		method: 'post',
		data: obj,
		noLoading: true
	})
}

// 根据id修改人员资料
export function editRenyuanById (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custInfo/updateDetailCustInfo',
		method: 'post',
		data: obj,
		encryption: ['mobile', 'idCard', 'emerContactCard', 'emerContactNum']
	})
}

// 根据id删除人员资料
export function delRenyuanById (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custInfo/cancelCustInfo',
		method: 'delete',
		data: obj
	})
}

// 新增人员资料
export function addRenyuan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custInfo/addCustInfo',
		method: 'post',
		data: obj,
		encryption: ['mobile', 'idCard', 'emerContactCard', 'emerContactNum']
	})
}

// 获取人员资料详情
export function getRenyuanDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custInfo/queryCustInfoDetail',
		method: 'get',
		params: obj
	})
}

// 保存人员生物识别特征
export function saveRenyuanPhoto (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custInfo/saveCustPhoto',
		method: 'post',
		data: obj
	})
}

// 获取慈云token
export function getToken (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/lethird/api/ciyun/getAccessToken',
		method: 'post',
		data: obj
	})
}

// 获取慈云token
export function getCust (data) {
	return request({
		url: '/lethird/api/ciyun/sync/healthInfo',
		method: 'post',
		data
	})
}

// 新增副卡人员
export function custCard (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/cust/slave/add',
		method: 'post',
		data: obj
	})
}
// 编辑副卡人员
export function xiuCustCard (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/cust/slave/update',
		method: 'post',
		data: obj
	})
}
// 副卡人员发卡
export function faka (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/cust/slave/send/card',
		method: 'post',
		data: obj
	})
}
// 副卡人员换卡
export function fuhuanka (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/cust/slave/change/card',
		method: 'post',
		data: obj
	})
}
// 卡片挂失
export function guashis (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/cust/slave/report/loss/card',
		method: 'post',
		data: obj
	})
}

// 卡片解挂
export function jieguas (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/cust/slave/release/card',
		method: 'post',
		data: obj
	})
}
// 删除主卡下所有副卡
export function delcustall (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/cust/slave/delete/all',
		method: 'post',
		data: obj
	})
}
// 删除单个副卡
export function delcust (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/cust/slave/delete/single',
		method: 'post',
		data: obj
	})
}
// 获取主卡下的所有副卡
export function getCustAlls (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/cust/slave/list',
		method: 'post',
		data: obj
	})
}
// 获取慈云token
export function getCustAll (data) {
	return request({
		url: '/lethird/api/ciyun/sync/healthInfoAll',
		method: 'post',
		data
	})
}

// 分页查询临时用户
export function getLinshiList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custCasual/queryPageCustCasual',
		method: 'get',
		params: obj
	})
}

// 分页查询账户资料
export function getZhanghuList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accInfo/queryPageAccInfo',
		method: 'post',
		data: obj
	})
}

// 根据id注销账户
export function delZhanghuById (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accInfo/cancelAccountById',
		method: 'put',
		data: obj
	})
}

// 办卡
export function banka (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accInfo/applyCard',
		method: 'post',
		data: obj
	})
}

// 卡片挂失
export function guashi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accInfo/reportLossCard',
		method: 'put',
		data: obj
	})
}

// 卡片解挂
export function jiegua (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accInfo/releaseReportLossCard',
		method: 'put',
		data: obj
	})
}

// 换卡
export function huanka (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accInfo/replaceCard',
		method: 'post',
		data: obj
	})
}

// 账户解冻
export function jiedong (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accInfo/relieveFreezeAccInfo',
		method: 'put',
		data: obj
	})
}

// 账户冻结
export function dongjie (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accInfo/freezeAccInfo',
		method: 'put',
		data: obj
	})
}

// 取款
export function qukuan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/recharge/drawMoney',
		method: 'put',
		data: obj
	})
}

// 补贴充值
export function butieChongzhi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/recharge/subsidyRecharge',
		method: 'post',
		data: obj
	})
}

// 个人钱包充值
export function moneyChongzhi (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/recharge/personalRecharge',
		method: 'put',
		data: obj
	})
}

// 分页查询人员职位职称
export function getPosition (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custJob/queryPageCustJob',
		method: 'get',
		params: obj
	})
}

// 全量查询人员职位职称
export function getAllPosition (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custJob/queryAllCustJob',
		method: 'get',
		params: obj
	})
}

// 根据id修改职位职称
export function editPosition (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custJob/updateCustJobById',
		method: 'put',
		data: obj
	})
}

// 新增人员职位职称
export function addPosition (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custJob/addCustJob',
		method: 'post',
		data: obj
	})
}

// 根据主键id，删除职位职称
export function delPosition (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custJob/deleteCustJobById',
		method: 'delete',
		data: obj
	})
}

// 查询全量慢性病信息
export function getAllSick (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custChronic/queryAllCustChronic',
		method: 'get',
		params: obj
	})
}

// 分页查询慢性病信息
export function getSick (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custChronic/queryPageCustChronic',
		method: 'get',
		params: obj
	})
}

// 修改慢性病信息
export function editSick (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custChronic/updateCustChronicById',
		method: 'put',
		data: obj
	})
}

// 新增慢性病信息
export function addSick (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custChronic/addCustChronic',
		method: 'post',
		data: obj
	})
}

// 根据慢性病id，删除慢性病信息
export function delSick (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custChronic/deleteCustChronic',
		method: 'delete',
		data: obj
	})
}

// 查询补贴规则列表
export function getButieRules (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accSubRule/queryAllAccSubRule',
		method: 'get',
		params: obj
	})
}

// 查询补贴规则列表---新
export function getNewButieRules (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2.1/sub/time/list',
		method: 'post',
		data: obj
	})
}

// 新增补贴规则
export function addButieRules (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accSubRule/addAccSubRule',
		method: 'post',
		data: obj
	})
}
// 新增补贴规则---新
export function addNewButieRules (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2.1/sub/time/add',
		method: 'post',
		data: obj
	})
}

// 根据id修改补贴规则
export function editButieRules (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accSubRule/updateAccSubRuleById',
		method: 'post',
		data: obj
	})
}

// 根据id修改补贴规则---新
export function editNewButieRules (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2.1/sub/time/update',
		method: 'post',
		data: obj
	})
}

// 根据id删除补贴规则
export function delButieRules (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accSubRule/deleteAccSubRuleById',
		method: 'post',
		data: obj
	})
}

// 批量导入充值
export function exportRecharge (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}

	return request({
		url: '/recharge/batchImportRecharge',
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		method: 'post',
		data
	})
}

// 导入excel
export function uploadExcel (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custInfo/batchImportCustAcc',
		method: 'post',
		data
	})
}
// 导入健康信息excel
export function uploadHealthExcel (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custInfo/batchImportCustHealth',
		method: 'post',
		data
	})
}

// 查询账户充值记录
export function queryPageRecharge (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/recharge/queryPageRecharge',
		method: 'post',
		data: obj
	})
}

// 人员批量充值
export function personRecharge (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/wallet/batch/recharge/per',
		method: 'post',
		data: obj
	})
}

// 组织机构批量充值
export function orgRecharge (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/wallet/batch/recharge/org',
		method: 'post',
		data: obj
	})
}

// 组织机构批量补贴充值
export function orgRechargeSub (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/subsidy/batch/recharge/org',
		method: 'post',
		data: obj
	})
}

// 人员批量补贴充值
export function personalRechargeSub (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/subsidy/batch/recharge/per',
		method: 'post',
		data: obj
	})
}

// 批量生成特征值
export function saveCustPhotoUnion (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custInfo/saveCustPhotoUnion',
		method: 'post',
		data: obj
	})
}

// 人员类别---新增人员类别
export function addPsnType (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/cust/psntype/savePsnType',
		method: 'post',
		data: obj
	})
}

// 人员类别---修改人员类别
export function editPsnType (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/cust/psntype/updatePsnTypeById',
		method: 'put',
		data: obj
	})
}

// 人员类别---查询人员类别
export function getPsnType (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/cust/psntype/queryPsnTypeByPage',
		method: 'get',
		params: obj
	})
}

// 退款记录查询
export function tuikuanjilu (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repordcenter/rep/ordcenter/refund',
		method: 'post',
		data: obj
	})
}

// 更新卡类型和是否验证
export function changeBaseInfo (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/basecard/changeBaseInfo',
		method: 'post',
		data: obj
	})
}

// 批量注销人员
export function delPersonall (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custInfo/batchCancelCustInfo',
		method: 'post',
		data: obj
	})
}
// 清空个人补贴账户
export function accsubsidy (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accClc/personal/clear',
		method: 'post',
		data: obj
	})
}
// 批量清空个人补贴账户
export function accbatchsubsidy (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accClc/batch/clear',
		method: 'post',
		data: obj
	})
}
// 批量账户,补贴充值结果
export function getchognzhiJieguo (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/recharge/list',
		method: 'post',
		data: obj
	})
}
// 补贴充值待生效记录
export function getbutieHistory (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/subsidy/pending/list',
		method: 'post',
		data: obj
	})
}

// 新增卡片绑定
export function addCardbind (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accCardBind/add',
		method: 'post',
		data: obj
	})
}
// 分页查询卡片绑定
export function getCardbind (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accCardBind/queryPageBindHist',
		method: 'post',
		data: obj
	})
}
// 删除卡片绑定
export function delCardbind (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accCardBind/remove',
		method: 'delete',
		data: obj
	})
}
// 批量导入卡片绑定
export function exportCardbinds (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accCardBind/batchImportBind',
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		method: 'post',
		data
	})
}
// 组织架构根据组织id集合批量修改组织
export function plEditorg (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custOrg/batchUpdateCustOrg/org',
		method: 'post',
		data: obj
	})
}
// 组织架构根据人员集合批量修改组织
export function plEditcust (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custOrg/batchUpdateCustOrg/cust',
		method: 'post',
		data: obj
	})
}

// 分页查询分页查询
export function queryPageAccCardDeductionHist (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accCardDeduction/queryPageAccCardDeductionHist',
		method: 'post',
		data: obj
	})
}

// 批量导入人员补扣信息
export function pldaorupersonkou (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/acc/repair/deduct/batch/import',
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		method: 'post',
		data
	})
}
// 人员批量修改账户最低余额限制
export function plEditbatchPerAccBalanceLimit (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accInfo/batchPerAccBalanceLimit',
		method: 'post',
		data: obj
	})
}
// 获取批量补扣异常信息列表
export function pldaoruyichang (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/acc/repair/deduct/err/list',
		method: 'post',
		data: obj
	})
}
// 获取所有转账相关交易类型
export function getZhuanzhangtradeTypeEnum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/recharge/accTransferTradeTypeEnum',
		method: 'get',
		params: obj
	})
}
// 获取所有充值相关交易类型
export function getChongzhitradeTypeEnum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/recharge/accRechargeTradeTypeEnum',
		method: 'get',
		params: obj
	})
}

// 获取所有取款相关交易类型  -- 新
export function getQukuantradeTypeEnumNew (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/expend/withdrawal/tradeType',
		method: 'get',
		params: obj
	})
}

// 批量导入修改人员信息
export function uploadeditExcel (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custInfo/batchImportUpdateCust',
		method: 'post',
		data
	})
}
// 获取所有tradeType
export function getAlltradetype (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/recharge/allTradeTypeEnum',
		method: 'get',
		params: obj
	})
}
// 账户中心-批量补扣异常列表导出
export function exportPlbukouyichang (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/acc/repair/deduct/err/export',
		method: 'post',
		responseType: 'blob',
		data: obj
	})
}
// 自动获取补扣金额
export function getBukouamount (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mkttimequota/quota/amount',
		method: 'post',
		data: obj
	})
}

// 打包下载人脸照片
export function downloadAllPhoto (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custInfo/downloadAllPhoto',
		method: 'get',
		params: obj,
		responseType: 'blob'
	})
}
//  批量解冻冻结账户(一键解冻)
export function unfreeze (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accFreeze/batch/unfreeze/per',
		method: 'post',
		data: obj
	})
}
// 删除人员资料人员照片和特征值
export function delPhotoByCustId (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/custInfo/delPhotoByCustId/${data.custId}`,
		method: 'delete',
		data: obj
	})
}
// 分页查询报警信息列表
export function getAlarmByPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/weigh/alarm/getByPage',
		method: 'get',
		params: obj
	})
}

// 分页查询注销记录
export const pageCustCancel = data => {
	return request({
		url: '/cust/cancel/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 批量打包下载位置信息二维码
export function downloadAllPlace (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/custPlace/downloadAllPlace/${data}`,
		method: 'get',
		params: obj,
		responseType: 'blob'
	})
}

// 批量绑定订餐员
export const batchBindUserId = data => {
	return request({
		url: '/custPlace/batchBindUserId',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 批量绑定菜谱
export const batchBindRecipes = data => {
	return request({
		url: '/custPlace/batchBindRecipes',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 获取用户绑定的所有位置
export function getPlaceByUser (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/custPlace/getPlaceByUser/${data.userId}`,
		method: 'get',
		params: obj
	})
}
// 获取用户绑定的所有位置
export function getDiningPlaceByOrgId (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/custOrg/query/diningPlace?orgId=${data.orgId}`,
		method: 'get',
		params: obj
	})
}
// 获取所有人员（字段较少）
export const getAllUsers = data => {
	return request({
		url: '/custInfo/page-cust-job-info',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
/** 人员健康监测记录
 * health-monitoring
 */
export function getHealthMonitoring (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	console.log(dataObj)
	if (data) {
		obj.content = data
	}
	return request({
		url: '/health/monitoring/page-health-monitoring',
		method: 'post',
		data: obj
	})
}
// 查询就餐地/工作地变更表
export const getCustChangeLog = data => {
	return request({
		url: '/cust-change-log/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
